import React, { useState, useEffect } from "react";
import ImagePopup from "./../ImagePopup";
import {
  getNIDDetailsWithOCR,
  verifyProfileChecks,
  generateCaptcha,
  sendOtp,
  verifyOtp,
  savePan,
  nextTabApi,
  getAadharDigiUrl,
} from "../../Actions/nidAction";

import SampleDocsUpload from "../../UI_Design/InstantNIDWithOCR/assets/SampleDocsUpload.png";


import InputField from "./../InputField";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import _ from "lodash";
import Loader from "../Common/loader";
import { useNavigate } from "react-router-dom";
import ImageViewerNID from "../Common/ImageViewerNID";
import { validateAadhaar, validatePAN } from "../../Helper/common";
import ConfirmationPopup from "../EmploymentForm/confirmationPopup";
import NIDConfirmationPopup from "./NIDConfirmationPopUp";
import axios from "axios";
import { getData } from "../../Actions/landingAction";

const InstantNIDForm = ({
  field,
  nidOptions,
  fieldKey,
  handleInputChange,
  nidFieldIndex,
  uploadFile,
  disabledOptionsArray = [],
  handleFileDelete,
  selectedFieldName,
  ibridgeField,
  saveDateInput,
  nidAllDetails,
  handleContinueRedirection,
  getIsMandatoryFlag,
  globalRotatedBlobObj,
  setGlobalRotatedBlobObj,
  activeCaseCheck,
  isDigi
}) => {
  const [nidOptionsArray, setNidOptionsArray] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [image, setImage] = useState("");
  const [errorData, setErrorData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [inputArray, setInputArray] = useState({});

  const [idNumber, setIdNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [timer, setTimer] = useState(60);
  const [verified, setVerified] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showContinue, setShowContinue] = useState(false);
  const [showAContinue, setShowAContinue] = useState(false);
  // const [data,setData]=useState();
  const [captchaData, setCaptchaData] = useState();

  const storeData = useSelector((state) => state.verifyProfileChecks);
  const storeData1 = useSelector((state) => state.generateCaptcha);
  const storeData2 = useSelector((state) => state.sendOtp);
  const storeData3 = useSelector((state) => state.verifyAOtp);
  const storeSavePan = useSelector((state) => state.savePan);

  const { verifyProfileChecksData, loading: getNIDLoading } = storeData;
  const { generateCaptchaReducerData, loading: Loading } = storeData1;
  const { sendOtpReducerData, loading: sentOtpLoading } = storeData2;
  const { verifyOtpReducerData, loading: otpLoading } = storeData3;
  const { savePanReducerData, loading: savePanLoading } = storeSavePan;

  const [verifyObj, setVerifyObj] = useState({});
  const [sendOtpObj, setSendOtpObj] = useState({});

   const [showImageViewer, setShowImageViewer] = useState(false);
   const [inputValidationError, setInputValidationError] = useState({});
   const [nidCheckId, setNidCheckId] = useState(null);
   const [nidDocId, setNidDocId] = useState(null);
   const [nidSubCheckId, setNidSubCheckId] = useState(null);
   const [nidCaseCheckId, setNidCaseCheckId] = useState(null);
   const [showConfirmation, setShowConfirmation] = useState(false);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    const flag = nidAllDetails?.mobile_aadhar_linked;
    if (flag != null) {
      if (flag == 0) {
        setActiveIndex(1);
      }
      if (flag == 1) {
        setActiveIndex(0);
      }
    }
  }, [fieldKey]);

  useEffect(() => {
    console.log(verifyProfileChecksData, "jjj");
    if (
      typeof verifyProfileChecksData !== "undefined" &&
      verifyProfileChecksData !== null
    ) {
      setVerifyObj(verifyProfileChecksData);
      // if(verifyProfileChecksData.status=="success"){
      setVerified(true);
      setShowContinue(true);
      // setData(verifyProfileChecksData.data);
      // }
    }
  }, [verifyProfileChecksData, storeData]);

  useEffect(() => {
    if (typeof getNIDLoading !== "undefined" && getNIDLoading !== null) {
      if (getNIDLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getNIDLoading]);

  useEffect(() => {
    if (typeof savePanLoading !== "undefined" && savePanLoading !== null) {
      if (savePanLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [savePanLoading]);

  useEffect(() => {
    console.log(sendOtpReducerData, "kkk");
    if (
      typeof sendOtpReducerData !== "undefined" &&
      sendOtpReducerData !== null
    ) {
      // if(sendOtpReducerData.status=="success"){
      setIsVisible(true);
      setSendOtpObj(sendOtpReducerData);
      // }
    }
  }, [sendOtpReducerData, storeData2]);

  useEffect(() => {
    if (typeof sentOtpLoading !== "undefined" && sentOtpLoading !== null) {
      if (sentOtpLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [sentOtpLoading]);

  useEffect(() => {
    if (
      typeof generateCaptchaReducerData !== "undefined" &&
      generateCaptchaReducerData !== null
    ) {
      if (generateCaptchaReducerData.status == "success") {
        setCaptchaData(generateCaptchaReducerData.data);
      }
    }
  }, [generateCaptchaReducerData, storeData1]);


  useEffect(() => {
    let interval;
    if (isResendDisabled) {
      interval = setInterval(() => {
        if (timer === 0) {
          clearInterval(interval);
          setIsResendDisabled(false);
        } else {
          setTimer((prevTimer) => prevTimer - 1);
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isResendDisabled, timer]);

  useEffect(()=> {
    
    // check_id
    for (let i in field) {
      if (field[i].field_name == "check_id") {
       setNidCheckId(field[i]?.value)
      }
      if (field[i].field_name == "doc_id") {
        setNidDocId(field[i]?.value)
      }
      if (field[i].field_name == "case_check_id") {
        setNidCaseCheckId(field[i]?.value)
      }
      if (field[i].field_name == "sub_check_id") {
        setNidSubCheckId(field[i]?.value)
       }
    }
  },[field])
  const handleRadioClick = (index) => {
    if(!nidAllDetails?.is_aadhar_linked == null){
      return;
    }
    setActiveIndex(index);
    if (index == 0) {
      setShowVerify(true);
      dispatch(getNIDDetailsWithOCR());
    }
    if (index == 1) {
      setShowVerify(false);
      let record = {};
      record.is_aadhar_linked = "0";
      setShowAContinue(true);
      dispatch(getNIDDetailsWithOCR(record));
    }
    setErrorData({});
    setInputValidationError({})
  };

  const handleSavewithAadhar = () => {
    if (activeIndex == 0) {
      ibridgeField[394] = "1";
    } else {
      ibridgeField[394] = "0";
    }
    let error = "";
    if (activeIndex == 1) {
      error = formValidation();
    }
    if (error) {
      const msg = "Please fill all mandatory details.";

      toast.dismiss();

      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      handleSave();
    }
    console.log("weew", ibridgeField);
  };

  const formValidation = () => {
    let isError = false;
    const data = _.cloneDeep(field);
    const error = {};
    for (var key in data) {
      console.log(data[key]);
      if (data[key].input_type != 2 && data[key].input_type != 6) {
        if (data[key]?.is_mandatory && data[key]?.value?.trim() == "") {
          // errorObj[data[key].field_name] = "This field is required";
          isError = true;
          error[data[key].label] = true;
        }
      }
    }
    setErrorData(error);
    return isError;
  };

  const getNameId = (value = {}) => {
    switch (nidSubCheckId) {
      case 45:
        return [value.full_name, value.pan_number];
      case 142:
        return [value.Name, value["Voter Id"]];
      case 44:
        return [value["Given Name"], value["Passport no"]];
      case 101:
        return [value.full_name, value["dl_number"]];
      case 235:
        return [value.aadhar_name, value["aadhar"]];
      default:
        return [];
    }
  };
  const handleSave = (isAutoSave,callBackData) => {
    let record = {};
    let aadharNo;
    let aadharName;
    let docNumber;
    let value = verifyObj[nidSubCheckId] ? verifyObj[nidSubCheckId].value : {};
    if(isAutoSave) {
      value = callBackData[nidSubCheckId] ? callBackData[nidSubCheckId].value : {};
    }

    for (let i in field) {
      if (field[i].field_name == "case_check_id") {
        record.ele_check_id = [field[i]?.value];
      }
      if (field[i].field_name == "sub_check_id") {
        record.nid_selected = [`${field[i]?.value}`];
      }
      if (field[i].ibridge_field_id == 115) {
        aadharNo = field[i]?.value;
      }
      if (field[i].field_name == "doc_id") {
        docNumber = field[i]?.value;
      }
      if (field[i].ibridge_field_id == 114) {
        aadharName = field[i]?.value;
      }
    }

    const [name, id] = getNameId(value);
    record.ele_doc_name = [name];
    record.ele_doc_numb = [id];

    // for aadhar
    if (nidSubCheckId == 235) {
      const a = {};
      for (let i in field) {
        if (field[i].ibridge_field_id) {
          a[field[i].ibridge_field_id] = field[i].value;
        }
      }
      if (activeIndex == 0) {
        a[394] = "1";
      } else {
        a[394] = "0";
      }

      if (a) {
        if (activeIndex == 0 && !isDigi) {
          record.ele_doc_name = [value.aadhar_name];
          record.ele_doc_numb = [docNumber];
        } else {
          record.ele_doc_name = [aadharName];
          record.ele_doc_numb = [aadharNo];
          record.check_data = a;
        }
      }
    }
    if(globalRotatedBlobObj[fieldKey] && globalRotatedBlobObj[fieldKey][`front_image[]`]) {
      record.rotate_image_front = globalRotatedBlobObj[fieldKey][`front_image[]`];
    }
    if(globalRotatedBlobObj[fieldKey] && globalRotatedBlobObj[fieldKey][`back_image`]) {
      record.rotate_image_back = globalRotatedBlobObj[fieldKey][`back_image`];
    }
    // end

    console.log(verifyProfileChecksData);
    console.log(record);
    dispatch(savePan(record, activeIndex, callbackData));
  };

  const callbackData = (data) => {
    if(data?.group?.is_nid_pending == 1){
    }else{
      dispatch(getData());
    }
  }

  const getCheckInputValue = (s = "doc_id") => {
    let checkInput = "";
    for (let i in field) {
      if (field[i].field_name == s) {
        checkInput = field[i]?.value;
      }
    }
    return checkInput;
  };

  const handleButtonAClick = (e) => {
    const s = nidSubCheckId == 44 ? "file_no" : "doc_id";
    const checkInput = getCheckInputValue(s);
    let refno = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    e?.preventDefault(); // Prevent form submission
    // Handle logic for button A click here

    // for (let i in field) {
    //   if (field[i].field_name == "doc_id") {
    //     checkInput = field[i]?.value;
    //   }
    // }
    if(inputValidationError?.doc_id ) {
      return
    } else {
      if (checkInput) {
        console.log("nid checkinput..", checkInput);
        console.log("nid checkId..", nidCheckId)
        dispatch(
          verifyProfileChecks(
            {
              referenceNo: refno?.reference_number,
              check_data: {
                check_id: getCheckId(nidSubCheckId),
                check_value: checkInput,
              },
            },
            callback,
            nidSubCheckId
          )
        );
      }
    }
  };

  const getCheckId = (nidSubCheckId) => {
    switch (nidSubCheckId) {
      case 45:
        return 1;
      case 101:
        return 2;
      case 44:
        return 3;
      case 142:
        return 4;
      default:
        return "";
    }
  };

  const callback = (data) => {
    // setVerified(true);
    handleSave(true, data)
  };

  const handleButtonDClick = (e) => {
    e.preventDefault(); // Prevent form submission
    let aadhar;
    let caseCheckId;
    let refno = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    let record = {};
    let recordId = ''
    for (let i in field) {
      if (field[i].field_name == "doc_id" || field[i]?.label == "Aadhaar Card No") {
        aadhar = field[i]?.value;
        recordId = i;
      }
    }

    let error = formValidation();

    // let error = '';

    if (!aadhar) {

      setErrorData((prev) => ({
        ...prev,
        [field[recordId].label] : true
      }))

      // const msg = "Please fill all mandatory details.";

      // toast.dismiss();

      // toast.error(msg, {
      //   position: "top-right",
      //   autoClose: 2000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
    } else {
      // handleSave();

      if(!validateAadhaar(aadhar)){
        setInputValidationError(prevState => ({
          ...prevState,
          [field[recordId].label] : true
        }))
        return;
      }else{
        setInputValidationError(prevState => ({
          ...prevState,
          [field[recordId].label] : false
        }))
      }

    // removing the existing otp flow
    // aadhar=aadhar.trim();
    // record.tsTransID = captchaData.tsTransID;
    // record.secretToken = captchaData.secretToken;
    // record.valueCaptcha = 1234;
    // record.aadhar_no = aadhar;
    // setOtp("");
    record.aadhar_no = aadhar;
    record.case_check_id = activeCaseCheck?.case_check_id;
    dispatch(getAadharDigiUrl(record, callbackAadharVerify, activeCaseCheck?.case_check_id));
    // Handle logic for button A click here
    // console.log("www",field);

    console.log(field);
    }
  };
  const handleButtonBClick = (e) => {
    let record = {};
    record.tsTransID = captchaData.tsTransID;
    record.otp = otp;
    dispatch(verifyOtp(record, callbackAadhar, nidSubCheckId));
    e.preventDefault(); // Prevent form submission
    // Handle logic for button B click here
    if (otp === "123456") {
      // Replace '123456' with the correct OTP validation logic
      setShowError(false);
      // Proceed with verification
    } else {
      setShowError(true);
    }
  };

  const callbackAadharVerify = (data) => {
    // setShowAContinue(false);
    if(data && data?.url){
      window.location.href = data?.url;
    }
  };

  const callbackAadhar = () => {
    // setIsAadharVerified(true);
    // setIsVisible(true);
  };
  const handleResendOTPClick = (e) => {
    let record = {};
    let aadhar;
    for (let i in field) {
      if (field[i].field_name == "doc_id") {
        aadhar = field[i]?.value;
      }
    }
    record.tsTransID = captchaData.tsTransID;
    record.secretToken = captchaData.secretToken;
    record.valueCaptcha = 1234;
    record.aadhar_no = aadhar;
    setOtp("");
    dispatch(sendOtp(record, () => {}, true));
    e.preventDefault(); // Prevent form submission
    // Handle logic for resending OTP here
    setIsResendDisabled(true);
    setTimer(60); // Reset the timer
  };


  const handleFileUpload = (inputName, selectedFile, files, errorField) => {
    const arr = fieldKey.split("_");
    const docName = arr[0] == "Aadhaar" ? "aadhaar" : arr[0];
    let docCheckID = null;
    let docSubCheckID = null;
      setGlobalRotatedBlobObj(prevState => ({
        ...prevState,
        [fieldKey] : {
          ...prevState[fieldKey],
          [inputName]: null
        }
      }))
    if (fieldKey !== "NID_Default_Field") {
      for (let i in nidOptions) {
        if (nidOptions[i].toLowerCase().includes(docName.toLowerCase())) {
          docCheckID = i;
        } else {
          docCheckID = nidCheckId;
        }
      }
      docCheckID = nidCheckId;
    } else {
      docCheckID = 72;
    }

    if (fieldKey === "NID_Default_Field") {
      for (let i in nidOptions) {
        if (nidOptions[i] === nidCheckId) {
          docSubCheckID = i;
        }
      }
    } else {
      docSubCheckID = nidSubCheckId;
    }
    const docSide = inputName.includes("front") ? "front" : "back";
    //  const checkIDData = field[Object.keys(field).length - 1].value;
    const checkIDData = nidCaseCheckId;
    console.log(checkIDData, docSubCheckID, docCheckID, "ffgg");
    setErrorData({});
    uploadFile(
      docCheckID,
      docSubCheckID,
      docSide,
      fieldKey,
      checkIDData,
      selectedFile,
      inputName,
      nidFieldIndex,
      errorField,
      activeIndex
    );
  };
  const handleDelete = (e, errorField, inputName, inputDocId) => {
    e.preventDefault();
    e.stopPropagation();
    const recordArray = {};
    const docSide = inputName.includes("front") ? "front" : "back";
    recordArray.doc_side = docSide;
    recordArray.doc_ids = inputDocId;
    if(globalRotatedBlobObj[fieldKey] && globalRotatedBlobObj[fieldKey][inputName]){
      let newRotatedObj = {...globalRotatedBlobObj}
      delete globalRotatedBlobObj[fieldKey][inputName];
      setGlobalRotatedBlobObj(newRotatedObj)
    }
    setErrorData({});
    handleFileDelete(recordArray, errorField, activeIndex, nidSubCheckId);
  };

  const handleImageModal = (e, modalImage) => {
    e.preventDefault();
    e.stopPropagation();
    setImage(modalImage);
    setShowImageModal(!showImageModal);
  };

  const handleMouseEnter = (e, modalImage) => {
    e.preventDefault();
    e.stopPropagation();
    setImage(modalImage);
    setShowImageViewer(true);
  }

  const handleMouseLeave = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setImage("");
    setShowImageViewer(false);
  }

  const closePopup = () => {
    setImage("");
    setShowImageModal(false);
  };

  const handleRotate = async (e, imageUrl, rotateDirection = 'right', inputName, errorField, domID) => {
    e?.preventDefault();
    e?.stopPropagation();
  
    try {
      const previewImg = document.getElementById(domID);
      const currentImageSrc = previewImg?.src || imageUrl;
  
      let blob;
  
      if (currentImageSrc.startsWith('blob:')) {
        // 🟡 Use fetch for blob URLs
        const response = await fetch(currentImageSrc);
        blob = await response.blob();
      } else {
        // 🟢 Use axios for external image URLs
        const response = await axios.get(currentImageSrc, {
          responseType: 'blob',
        });
        blob = response.data;
      }
  
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = URL.createObjectURL(blob);
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        const angle = rotateDirection === 'right' ? 90 : -90;
  
        canvas.width = img.height;
        canvas.height = img.width;
  
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((angle * Math.PI) / 180);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
  
        canvas.toBlob((rotatedBlob) => {
          if (rotatedBlob) {
            const rotatedFile = new File([rotatedBlob], `${inputName || "NID"}_rotated-image.jpg`, { type: "image/jpeg" });
            const rotatedImageUrl = URL.createObjectURL(rotatedBlob);

            if(rotatedFile){
              setGlobalRotatedBlobObj(prevState => ({
                ...prevState,
                [fieldKey] : {
                  ...prevState[fieldKey],
                  [inputName]: rotatedFile
                }
              }))
            }
  
            handleInputChange(inputName, rotatedImageUrl)
  
            // Optional: handleFileUpload(inputName, rotatedFile, "", errorField);
          }
        }, 'image/jpeg', 1);
      };
    } catch (error) {
      console.error('Error rotating image:', error);
    }
  };
  

  const checkDocID = () => {
    let flag = false;
    for (let i in field) {
      if (field[i].field_name == "doc_id" || field[i]?.label == "Candidate Name as per Document" ) {
        let aadharNo = field[i]?.value;
        if (!aadharNo) {
          return true;
        }
      }
      if (field[i].field_name == "front_image[]") {
        let image = field[i]?.value;
        if (!image) {
          return true;
        }
      }
      if (field[i].field_name == "back_image") {
        let image = field[i]?.value;
        if (!image) {
          return true;
        }
      }
    }
    return flag;
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  console.log(field, "ggg");

  const handleNextTab = () => {
    // apiCall
    let fieldEntries = Object.entries(field || {});
    const caseCheckfield = fieldEntries?.find(([key, value], index) => value?.field_name === "case_check_id");
    // console.log("caseCheckId...", caseCheckfield[1].value)
    const payload = { case_check_id: caseCheckfield[1].value };
    dispatch(nextTabApi(payload, callbackRedirection,setIsLoading));
    // callbackRedirection()
  };

  const callbackRedirection = (data) => {
    handleContinueRedirection(data);
  };

  const getIsMandatory = (field) => {
    return !getIsMandatoryFlag(field);
    // console.log(field);
  };
  return (
    <>
      {isLoading && <Loader />}
      {
        showConfirmation && (
          <NIDConfirmationPopup
          showModalBox={1}
          closePopup={(e) => {
            e?.preventDefault();
            setShowConfirmation(false);
          }}
          title={``}
          description={`Please confirm if ${selectedFieldName} belongs to you : `}
          docIDNumber={nidDocId}
          proceedHandler={(e) => {
            e?.preventDefault();
            handleButtonAClick(e);
            setShowConfirmation(false);
            // proceedAdd();
          }}
          isAdd={true}
          yesOption = "Confirm"
          noOption = "Edit"
        />
        )
      }
      {showImageModal && (
        <ImagePopup
          showModalBox={1}
          title={"Uploaded file"}
          description={"..."}
          isAdd={true}
          image={image}
          closePopup={closePopup}
        />
      )}
      {
        showImageViewer && (
          <ImageViewerNID
          showModalBox={1}
          title={"ViewUploaded file"}
          description={"..."}
          isAdd={true}
          image={image}
          closePopup={(e)=> handleMouseLeave(e)}
          />
        )
      }
      <div class="" style={{display: "flex", justifyContent: "space-between", maxWidth: 600, paddingLeft: 15, paddingRight: 15}}>
      <div>
        <h5 style={{marginTop: '-20px', marginBottom: '20px'}}>{selectedFieldName}</h5>
      </div>
      </div>
      <div
        className="container-fluid pb-5"
        style={{
          maxWidth: "99%",
          overflowX: "hidden",
          background: "#F9FAFB",
        }}
      >
  

        <div className="content py-2">

          {nidSubCheckId == 235 ? (
            <>
              <p className="ques">
                {/* Does your phone number need to be connected to your Aadhaar
                card? */}
                Is your phone number linked with Aadhaar ?
              </p>
              <div className="d-flex justify-content-start align-items-center">
                <div
                  className={`form-check form-check-inline d-flex align-items-center justify-content-center btn btn-outline-primary ${
                    activeIndex === 0 ? "active" : ""
                  } ${nidAllDetails?.mobile_aadhar_linked == null ? '' : "disabled"}`}
                  onClick={() => handleRadioClick(0)}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="radioOptions"
                    id="radioYes"
                    value="yes"
                    style={{
                      marginBottom: "4px",
                    }}
                    checked={activeIndex == 0 ? true : false}
                    disabled={!nidAllDetails?.mobile_aadhar_linked == null}
                  />
                  <label className="form-check-label" htmlFor="radioYes">
                    YES
                  </label>
                </div>
                <div
                  className={`form-check form-check-inline d-flex align-items-center justify-content-center btn btn-outline-primary ${
                    activeIndex === 1 ? "active" : ""
                  } ${nidAllDetails?.mobile_aadhar_linked == null ? '' : "disabled"} `}
                  onClick={() => handleRadioClick(1)}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="radioOptions"
                    id="radioNo"
                    value="no"
                    style={{
                      marginBottom: "4px",
                    }}
                    checked={activeIndex == 1 ? true : false}
                    disabled={!nidAllDetails?.mobile_aadhar_linked == null}
                  />
                  <label className="form-check-label" htmlFor="radioNo">
                    NO
                  </label>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {!(nidSubCheckId == 235 && activeIndex == null || (nidSubCheckId == 235 && activeIndex == 0) ) && (
            <div className="py-2 mt-2">
              <p className="supportText">
                Please upload clear photos of required ID
              </p>
              <p className="ques font-weight-bold">
                {/* Upload {selectedFieldName} */}
                Image Guidelines:
              </p>
              <img
                className="w-100"
                style={{ maxWidth: "276.73px" }}
                src={SampleDocsUpload}
                alt="SampleDocsUpload"
              />
            </div>
          )}

          {/* DocsDetail */}
          {!(nidSubCheckId == 235 && activeIndex == null) && (
            <div className="docsDetail py-3">

              {field &&
                Object.keys(field).map((inputField, key) => {
                  const nidDetails = field;
                  let s = nidDetails[inputField]?.ibridge_field_id;
                  console.log(s);
                  return (
                    <>
                      {true && (
                        <>
                          <div className="row">
                            {nidDetails[inputField].input_type !== 6 &&
                            nidDetails[inputField].input_type !== 2 ? (
                              <div className="col-sm-4 col-md-12 col-xl-4">
                                 {
                                      !!(nidDetails[inputField] && nidDetails[inputField].field_name === "doc_id") &&
                                      <div style={{marginBottom : 20}}>
                                        <small className="text-muted" style={{fontWeight: 700}}>{`Please verify if the given ${selectedFieldName || "ID"} number is correct`}</small>
                                      </div>
                                    }
                                <div
                                  className={
                                    nidDetails[inputField].input_type == 8
                                      ? ""
                                      : "form-group mt-2"
                                  }
                                >
                                  <InputField
                                    inputType={
                                      nidDetails[inputField].input_type
                                    }
                                    inputName={
                                      nidDetails[inputField].field_name
                                        ? nidDetails[inputField].field_name
                                        : nidDetails[inputField].label
                                    }
                                    inputValue={nidDetails[inputField].value}
                                    inputDocId={
                                      nidDetails[inputField].id
                                        ? nidDetails[inputField].id
                                        : null
                                    }
                                    isInputMandatory={
                                      nidDetails[inputField].is_mandatory &&
                                      nidDetails[inputField].input_type != 6
                                    }
                                    inputLabel={!!(nidDetails[inputField].label === "ID Number" && selectedFieldName) ? `${selectedFieldName} Number`: nidDetails[inputField].label}
                                    handleOnChange={(e) => {
                                      let label = nidDetails[inputField].label
                                      handleInputChange(
                                        e.target.name,
                                        e.target.value,
                                        fieldKey,
                                        key,
                                        nidFieldIndex,
                                        inputField,
                                        nidDetails[inputField]?.ibridge_field_id
                                      )
                                      // errors handled separately in each tab
                                      if((e?.target?.name === "doc_id" || e?.target?.name === "Aadhaar Card No") && e?.target?.value) {
                                        if(selectedFieldName?.toUpperCase() == "PAN CARD") {
                                          setInputValidationError(prevState => ({
                                            ...prevState,
                                            "doc_id" : !validatePAN(e?.target?.value)
                                          }))
                                        } else if (selectedFieldName?.toUpperCase() == "AADHAR CARD") {
                                          setInputValidationError(prevState => ({
                                            ...prevState,
                                            "doc_id" : !validateAadhaar(e?.target?.value)
                                          }))
                                        }else if(selectedFieldName?.toUpperCase() == "AADHAAR"){
                                          setInputValidationError(prevState => ({
                                          ...prevState,
                                          [e?.target?.name] : !validateAadhaar(e?.target?.value)
                                        }))
                                        setErrorData((prev) => ({
                                          ...prev,
                                          [e?.target?.name] : false
                                        }))
                                      }
                                      } else if ((e?.target?.name === "doc_id" )&& !e?.target?.value) {
                                        setInputValidationError(prevState => ({
                                          ...prevState,
                                          "doc_id" : false
                                        }))
                                      } 
                                      else if(selectedFieldName?.toUpperCase() == "AADHAAR" && !e?.target?.value){
                                          setInputValidationError(prevState => ({
                                          ...prevState,
                                          [ e?.target?.name] : false
                                        }))
                                      } 
                                    }

                                    }
                                    saveDate={(index, argDate) => {
                                      saveDateInput(
                                        nidDetails[inputField].field_name,
                                        argDate,
                                        fieldKey,
                                        key,
                                        nidFieldIndex,
                                        inputField,
                                        nidDetails[inputField]?.ibridge_field_id
                                      );
                                    }}
                                    options={
                                      nidDetails[inputField]?.options ||
                                      nidOptionsArray
                                    }
                                    // isFileUploadedObject={isFileUploadedObject}
                                    handleFileUpload={handleFileUpload}
                                    // errorField={errorField}
                                    handleDelete={handleDelete}
                                    // uploadedFileName={uploadedFileName}
                                    uploadedFilePreview={
                                      nidDetails[inputField].input_type == 8
                                        ? nidDetails[inputField].value &&
                                          nidDetails[inputField].value != ""
                                          ? nidDetails[inputField].value
                                          : "n.a."
                                        : "n.a."
                                    }
                                    disabledOptionsArray={disabledOptionsArray}
                                    handleImageModal={handleImageModal}
                                    readOnly={
                                      nidAllDetails?.check_status?.[fieldKey] || isDigi
                                        ? true
                                        : false
                                    }
                                    disabled={
                                      nidAllDetails?.check_status?.[fieldKey]
                                        ? true
                                        : false
                                    }
                                    // errorField={errorField}
                                    showBlankOption={
                                      fieldKey === "NID_Default_Field"
                                        ? true
                                        : false
                                    }
                                    // isPan={isPan}
                                    handleMouseEnter = {handleMouseEnter}
                                    handleMouseLeave = {handleMouseLeave}
                                    handleRotate = {handleRotate}
                                    rotateOptions = {true}
                                  />
                                  {errorData[nidDetails[inputField]?.label] ? (
                                    <p className="text-danger">
                                      This field is required
                                    </p>
                                  ) : inputValidationError[nidDetails[inputField]?.field_name] || inputValidationError[nidDetails[inputField]?.label] ? <p className="text-danger">
                                  {`Please Enter Valid ${selectedFieldName}`}
                                </p> : <></>}
                                  {/* <p className="text-danger">
                                {errorData[nidDetails[inputField].field_name]}
                              </p> */}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                          </div>
                        </>
                      )}
                    </>
                  );
                })}

              {!nidAllDetails.check_status?.[fieldKey] ? (
                <>
                  {nidSubCheckId != 235 ? (
                    <>
                      {" "}
                      <button
                        className={`btn btn-primary mb-4 ${
                          verifyObj[nidSubCheckId] &&
                          verifyObj[nidSubCheckId].isverified
                            ? "disabled"
                            : ""
                        }`}
                        onClick={(e) => setShowConfirmation(true)}
                        disabled={checkDocID()}
                      >
                        Submit
                      </button>
                    </>
                  ) : (
                    ""
                  )}

                  {nidSubCheckId == 235 && activeIndex == 0 && !isDigi ? (
                    <>
                      {" "}
                      <button
                        className={`btn btn-primary mb-4 ${
                          verifyObj[nidSubCheckId] &&
                          verifyObj[nidSubCheckId].isverified
                            ? "disabled"
                            : ""
                        }`}
                        onClick={(e) => handleButtonDClick(e)}
                        disabled={
                          checkDocID() ||
                          (sendOtpObj && sendOtpObj.isSentOtp) ||
                          (verifyObj[nidSubCheckId] &&
                            verifyObj[nidSubCheckId].isverified)
                        }
                      >
                        Verify
                      </button>
                      {verifyObj[nidSubCheckId] &&
                        verifyObj[nidSubCheckId].isverified && (
                          <div
                            className="text-success ml-2"
                            style={{ paddingBottom: "20px" }}
                          >
                            ✔️ Verified
                          </div>
                        )}{" "}
                    </>
                  ) : (
                    ""
                  )}

                  {nidSubCheckId == 235 &&
                    activeIndex == 0 &&
                    !(
                      verifyObj[nidSubCheckId] && verifyObj[nidSubCheckId].isverified
                    ) &&
                    sendOtpObj &&
                    sendOtpObj.isSentOtp && false &&(
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <h5>Verify OTP</h5>
                        <p className="supportText">
                          Enter OTP sent to your Aadhaar-linked number.
                        </p>
                        <div className="form-row pb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                          />
                        </div>
                        {!(
                          verifyObj[nidSubCheckId] &&
                          verifyObj[nidSubCheckId].isverified
                        ) ? (
                          <button
                            className="btn btn-link"
                            onClick={handleResendOTPClick}
                            disabled={isResendDisabled}
                          >
                            {isResendDisabled
                              ? `Resend OTP in ${timer}s`
                              : "Resend OTP"}
                          </button>
                        ) : (
                          ""
                        )}
                        {!(
                          verifyObj[nidSubCheckId] &&
                          verifyObj[nidSubCheckId].isverified
                        ) ? (
                          <button
                            className="btn btn-primary"
                            onClick={handleButtonBClick}
                          >
                            Verify OTP
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    )}

                  <div className="py-2">
                    {((verifyObj[nidSubCheckId] &&
                      verifyObj[nidSubCheckId].isverified) ||
                      activeIndex == 1 || isDigi) &&
                    nidSubCheckId== 235 ? (
                      <button
                        type="submit"
                        className="btn btn-primary ml-1"
                        onClick={handleSavewithAadhar}
                      >
                        Continue
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                activeIndex != 1 && (
                  <>
                  </>
                )
              )}

              {nidAllDetails?.check_status?.[fieldKey] 
            //   || getIsMandatory(fieldKey) 
              ? (
                <button
                  type="submit"
                  className="btn btn-primary ml-1"
                  onClick={handleNextTab}
                >
                  Next
                </button>
              ) : (
                ""
              )}

              {nidAllDetails.showProfilePreview == 1 && (
                <div className="row">
                  <div className="col-auto d-flex justify-content-between">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => handleSubmitForPreview(e)}
                    >
                      {clientId == 459831 ? "Preview" : "Submit for Preview"}
                    </button>
                  </div>
                  <div className="col-auto d-flex justify-content-between mt-4">
                    <small className="text-muted">
                      Please complete all the mandatory fields before final
                      submission
                    </small>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default InstantNIDForm;
